export * from './templates-sorter.component';
export * from './templates-sorter.component.module';